import { combineReducers } from 'redux';
import app from './app/reducer';
import verify from './../modules/verify/reducer';
import detail from './../modules/detail/reducer';
import cart from '../modules/cart/reducer';
import reward from '../modules/reward/reducer';
import pay from '../modules/pay/reducer'
import survey from '../modules/survey/reducer';

const createRootReducer = () =>
    combineReducers({
        app,
        verify,
        detail,
        cart,
        reward,
        pay,
        survey,
    });

export default createRootReducer;
